import React from "react"
import styled from "styled-components"
import {motion} from "framer-motion"

import Row from "./row.js"
import View from "./view.js"

const CustomRow = styled(
  React.forwardRef((props, ref) => {
    return <Row ref={ref} noshrink {...props} />
  })
)``
const MotionRow = motion.custom(CustomRow)

const CustomView = styled(
  React.forwardRef((props, ref) => {
    return <View ref={ref} noshrink {...props} />
  })
)``
const MotionView = motion.custom(CustomView)

export {MotionRow, MotionView}
